import { data } from "jquery";
import { smartStrategy } from "webpack-merge";
import restAction from "../common/restAction";
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import { router } from "../../../../router/index";
import i18nUtil from "../../../../locales/I18nUtil"

const state = { 
  socket: null,
  myAccessToken:"",
  loginDuplicatinoCheckUseYn: true
};
const mutations = { 
  setSocketConnect(state, payload){
    if( state.socket == null && state.loginDuplicatinoCheckUseYn){
      const param3= {
        url : "/api/org/getCodeValueList",
        method: 'post',
        obj:{},
        req: {
          cdCategory: 'tenant.env',
          cdKey: 'loginduplicationcheck'  
        }
      };
      restAction.actions.ASYNC_COWORK_REST_ACTION({}, param3)
      .then((res) =>{ 
        let codeList = res.result;
        let loginDuplicationCheck = codeList[0].cdValue;
        if (loginDuplicationCheck == "true") {
          state.loginDuplicatinoCheckUseYn = true;
          state.myAccessToken = localStorage.getItem("Authorization");
          let serverUrl = "/api/auth/websocket";
          state.socket = new SockJS(serverUrl, null, {transports: ["websocket"]});
          state.socket.protocol = 'v12.stomp';
          this.stompClient = Stomp.over(state.socket);
          this.stompClient.heartbeat.outgoing = 20000;
          this.stompClient.heartbeat.incoming = 0;
          this.stompClient.reconnect_delay = 5000;
          this.stompClient.debug = (msg) => {
            // console.log("SOCK:", msg);
          };
      
          this.stompClient.connect(
            { Authorization: localStorage.getItem("Authorization") },
            (frame) => {
              this.connected = true;
              console.log("Duplicate login check socket connected..");
        
              let obj = this;
              obj.stompClient.subscribe(
                "/api/auth/topic/login/subscribe/"+payload.userId,
                (message) => {
                  console.log("duplicate socket subscribe..");
                  let resData = JSON.parse(message.body);
                  if(state.myAccessToken.indexOf(resData.accessToken) == -1){
                    const param = {
                      url: '/api/auth/logout',
                      method: 'post',
                      obj:{},
                      req:{}
                    };
                    restAction.actions.ASYNC_COWORK_REST_ACTION({}, param)
                    .then(function(res) {
                      alert(i18nUtil.trans("TG001"));
                      localStorage.clear();
                      router.push("/login");
                      try { this.stompClient.disconnect(() => {}); } catch (ignore) { }
                      try { state.socket.close(); state.socket = null; } catch (ignore) { }
                      // if(location.host.indexOf("hanwhalife.com") > -1 && location.host != "cpdev.hanwhalife.com"){
                      //   obj.$router.push("/hcpsso/sso_login");
                      // }
                      // else{
                      // }
                    })
                    .catch(function(err) {console.log(err);});
      
                    const param2= {
                      url: '/neo/logout',
                      method: 'post',
                      obj:{},
                      req: {
                      }
                    };
                    restAction.actions.ASYNC_COWORK_REST_ACTION({}, param2)
                    .then(function(res) { })
                    .catch(function(err) { console.log(err); });
                  }
                }
              );
            },
            (error) => {
              console.log(error);
              this.connected = false;
            }
          );
        }else{
          state.loginDuplicatinoCheckUseYn = false;
          // console.log(" 중복차단 사용 안함; ");
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    } else if(!state.loginDuplicatinoCheckUseYn){
      // console.log( " Login Duplicateion Check Not Use ");
    } else{
      console.log( " socket already connected. ");
    }
  },
  setSocketDisConnect(state, payload){
    if(state.socket != null){
      try { this.stompClient.disconnect(() => {}); } catch (ignore) { }
      try { state.socket.close(); state.socket = null; } catch (ignore) { }
      console.log(" Socket disconnect complete.. ");
    }
  }
};
const actions = { };
const getters = { };
  
export default { state, actions, mutations, getters, namespaced: true };
  


// WEBPACK FOOTER //
// ./src/js/store/module/socket/mySocket.js